export default __webpack_public_path__ + "static/media/ordinacija-office.54f375e2.jpg";